"use client";

import { getFormProps, getInputProps, useForm } from "@conform-to/react";
import { parseWithZod } from "@conform-to/zod/v4";
import { useActionState } from "react";

import { FORM_VALIDATE_OPTIONS, formConstraint } from "@/components/forms/conform-options";
import { FieldError, FormError } from "@/components/forms/form-error";
import { LabelRow } from "@/components/forms/label-row";
import { SubmitButton } from "@/components/forms/submit-button";
import { Input } from "@/components/ui/input";
import { resetSchema } from "@/lib/auth/schemas";

import { resetPasswordAction } from "./actions";

const constraint = formConstraint(resetSchema);

export function ResetForm() {
  const [lastResult, action] = useActionState(resetPasswordAction, undefined);
  const [form, fields] = useForm({
    lastResult,
    constraint,
    ...FORM_VALIDATE_OPTIONS,
    onValidate({ formData }) {
      return parseWithZod(formData, { schema: resetSchema });
    },
  });

  return (
    <form {...getFormProps(form)} action={action} className="space-y-3">
      <FormError id={form.errorId} message={form.errors?.[0]} />
      <div className="space-y-1.5">
        <LabelRow htmlFor={fields.email.id}>Email</LabelRow>
        <Input
          {...getInputProps(fields.email, { type: "email" })}
          autoComplete="email"
          placeholder="you@example.com"
        />
        <FieldError id={fields.email.errorId} message={fields.email.errors?.[0]} />
      </div>
      <SubmitButton label="Send reset link" />
    </form>
  );
}
